import React from 'react';

const UpdatePrompt = ({ onUpdate }) => {
  return (
    <div style={{
      position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
      zIndex: 9999, display: 'flex', alignItems: 'center', gap: 14,
      background: 'rgba(15, 23, 42, 0.92)', backdropFilter: 'blur(16px)',
      WebkitBackdropFilter: 'blur(16px)',
      color: '#fff', padding: '14px 24px', borderRadius: 14,
      boxShadow: '0 12px 48px rgba(0,0,0,0.25), 0 0 0 1px rgba(255,255,255,0.06)',
      fontFamily: 'Inter, sans-serif', fontSize: 14, fontWeight: 500,
      animation: 'slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
      maxWidth: '90vw',
    }}>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#60a5fa" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 12a9 9 0 01-9 9 9 9 0 01-9-9 9 9 0 019-9 9 9 0 016.36 2.64"/>
        <polyline points="22 4 12 14 9 11"/>
      </svg>
      <span>A new version is available</span>
      <button onClick={onUpdate} style={{
        background: 'linear-gradient(135deg, #2563eb, #3b82f6)',
        border: 'none', color: '#fff', padding: '8px 20px', borderRadius: 8,
        fontWeight: 600, fontSize: 13, cursor: 'pointer',
        boxShadow: '0 4px 12px rgba(37,99,235,0.3)',
        transition: 'all 0.2s ease', marginLeft: 4,
      }}>
        Refresh
      </button>
      <style>{`@keyframes slideUp { from { transform: translateX(-50%) translateY(100px); opacity: 0; } to { transform: translateX(-50%) translateY(0); opacity: 1; } }`}</style>
    </div>
  );
};

export default UpdatePrompt;
